<template>
  <div class="buttons">
    <span
      v-for="(item, index) in getValues"
      :key="index"
      class="btn"
    >
      {{item.value}} {{getWord(index)}}
    </span>
  </div>
</template>

<script>
export default {
  name: 'timeRange',
  props: {
    data: [Array, Object]
  },
  computed: {
    getValues () {
      let arr = []
      try {
        arr = this.data.value.map(v => { return { value: v } })
      } catch (e) {
        console.log('等待按时间范围生成==>', e)
      }
      return arr
    }
  },
  methods: {
    getWord (index) {
      return index < this.getValues.length - 1 ? '至' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .buttons{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/IMTable/components/tdBox/components/timeRange/index.vue